// Translations come from the aem wrapper component
const state = {
 t: {
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email (this is your username)',
    invalidEmail: 'Email must be valid',
    userExists:'User Already Exists',
    fieldRequired: 'This field is required',
    unknownError: 'An unknown error occurred',
    continueAsGuest: 'Continue',
    agree2Terms: 'I have reviewed and understand the <a href="#1">Terms of Use</a> and <a href="#2">Privacy Policy</a>',
    refundPrivacy:
        'I have read, understand and agree to the <a href="#">Terms of Use</a> and <a href="#">Member Agreement</a> including the Limitation of Liability and Arbitration Policy.',
    accountExistsWithEmail: 'An account with this email address already exists',
    taxId: 'Government Tax ID',
    title: 'Sign In or Sign Up to Check Out',
    subtitle: 'There are a couple of benefits to creating a member account with us',
    becomeMember: 'Become a Member',
    haveAccount: 'I already have an account',
    description:
        '<ul><li>Here is the first one</li><li>Here is the second reason</li><li>Because we sell the best things</li></ul>',
    over18: 'I am 18-years-old or older',
    promo: "Yes, I'd like to recieve promotional materials from Nu Skin (optional)",
    promoEmail: 'Opt In to Emails',
    promoSMS: 'Opt In to SMS Text Messages',
    promoPhone: 'Mobile Phone',
    SMSDisclaimer: 'Message frequency will vary. Message and data rates may apply',
    SMSTerms: 'I have read, understand and agree to the <a href="#">SMS Terms and Conditions</a>.',
    createAccount: 'Create Your Account',
    promotionalCorrespondence: 'Promotional Correspondence',
    usernameHint: 'This is your username',
    welcome: 'Welcome to Nu Skin!',
    signin: 'Sign In',
    username: 'Username',
    passwordLabel: 'Password',
    signinButton: 'SIGN IN',
    signupButton: 'SIGN UP',
    show: 'SHOW',
    hide:'HIDE'
  }
};

//translationString.accountExistsWithEmail = 'An account with this email address already exists';
//translationString.usernameHint = 'This is your username';
state.t.agree2Terms = '';
state.t.refundPrivacy = '';
state.t.SMSTerms = '';

//state.t = translationString;

if (window.translations && Object.keys(window.translations).length > 0) {
  state.t = Object.assign(state.t, window.translations);
}

const getters = {};

const mutations = {};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
